// extracted by css-extract-rspack-plugin
export default {"link":"AuthButton-module__link___jSLWR","card":"AuthButton-module__card___IE0jb"};